// removed by extract-text-webpack-plugin
module.exports = {"name":"src-components-name----style-module---name---3XFFi","name__name":"src-components-name----style-module---name__name---lYnat","name__title":"src-components-name----style-module---name__title---1mozt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/name/style.module.scss
// module id = 316
// module chunks = 35783957827783